import { useRsrc } from '@/common/rsrc/RsrcContext';
import { StringUtils } from '@/common/utils/StringUtils';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export const ConfirmDeleteDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();

  const deleteEntity = () => {
    rsrc.delete(data.module, data.entity, data).then(closeDialog);
  };

  return (
    <Dialog open fullWidth onClose={closeDialog}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this {StringUtils.toCapitalizedWords(data.entity)} record?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={closeDialog}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={deleteEntity}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
